module.exports = __webpack_public_path__ + "static/33-417a433046cbba7697561299324acf9f.jpg";